// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"123":"80be0e53","320":"a11fb094","450":"355a5eae","720":"10e237b3","893":"cfac02af"}[chunkId] + ".chunk.js";
};